import { render, staticRenderFns } from "./editCKConfig.vue?vue&type=template&id=1b9386ac&scoped=true&"
import script from "./editCKConfig.vue?vue&type=script&lang=js&"
export * from "./editCKConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9386ac",
  null
  
)

export default component.exports